<script>
	import Router from './routes/index.svelte';
</script>
<main>
	<Router />
</main>
<style global lang="postcss">
		@tailwind base;
		@tailwind components;
		@tailwind utilities;
</style>